import React from 'react'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import { CCol, CRow, CCard, CCardBody } from '@coreui/react'
import './index.css'
import dayjs from 'dayjs'
import Highcharts from 'highcharts'
import drilldown from 'highcharts/modules/drilldown.js'
import HighchartsReact from 'highcharts-react-official'
import Loading from 'src/helpers/commons/loader'
import { wtGetFromLocalStorage, wtSaveToLocalStorage } from 'src/helpers/commons/LocalStorage'
import { wtFormatRoundedValue, wtRoundValue } from 'src/helpers/commons/utils'
import BaseListing from 'src/BaseListings'
import { Button, DatePicker, Select, Table } from 'antd'
import { WithRouter } from 'src/helpers/commons/WithRouter/WithRouter'
import WidgetFiscalYearSelector from 'src/widgets/Selectors/WidgetFiscalYearSelector'
import * as XLSX from 'xlsx'

const { RangePicker } = DatePicker
const monthOptions = Array.from({ length: 12 }, (_, index) => dayjs().month(index).format('MMMM')).map((month) => ({
  label: month,
  value: month,
}))

Highcharts.setOptions({
  credits: {
    enabled: false,
  },
})
class SalesDashboard extends BaseListing {
  constructor(props) {
    super(props)
    const branchOptions = wtGetFromLocalStorage('branches', []) || []

    this.state = {
      SalesDashboardData: null,
      isLoading: false,
      searchText: '',
      searchedColumn: '',
      branchOptions,
      selectedBranchIds: branchOptions.map((item) => +item.value || +item.id).filter((item) => item > 0),
      fiscalYears: [],
      salePerYearFiscalYearId: 0,
      salePerYearFiscalYearName: '',
      salePerYearRevenueLoading: false,
      salePerYearRevenueData: null,
      salePerYearLoading: false,
      salePerYearData: null,
      salePerYearSelectedRevenueAccountId: 0,
      salePerYearSelectedRevenueAccountName: '',
      salePerMonthFiscalYearId: 0,
      salePerMonthFiscalYearName: '',
      salePerMonthMonth: dayjs().format('MMMM'),
      salePerMonthRevenueLoading: false,
      salePerMonthRevenueData: null,
      salePerMonthLoading: false,
      salePerMonthData: null,
      salePerMonthSelectedRevenueAccountId: 0,
      salePerMonthSelectedRevenueAccountName: '',
      saleTodayFiscalYearId: 0,
      saleTodayFiscalYearName: '',
      saleTodayRevenueLoading: false,
      saleTodayRevenueData: null,
      saleTodayLoading: false,
      saleTodayData: null,
      saleTodaySelectedRevenueAccountId: 0,
      saleTodaySelectedRevenueAccountName: '',
      classWiseSalesFiscalYearId: 0,
      classWiseSalesFiscalYearName: '',
      classWiseSalesLoading: false,
      classWiseSalesData: { rows: [], totalRow: null },
      categoryWiseSalesFiscalYearId: 0,
      categoryWiseSalesFiscalYearName: '',
      categoryWiseSalesLoading: false,
      categoryWiseSalesData: { rows: [], totalRow: null },
      defaultFiscalYearId: 0,
      defaultFiscalYearName: '',
      dateRangeSectionLoading: false,
      dateRangeSectionData: [],
      dateRange: [dayjs(), dayjs()],
      hasInitialCardLoadRun: false,
    }
  }

  salesCardConfig = {
    sale_per_year: {
      title: 'Sale Per Year',
      revenueLoadingKey: 'salePerYearRevenueLoading',
      revenueDataKey: 'salePerYearRevenueData',
      departmentLoadingKey: 'salePerYearLoading',
      departmentDataKey: 'salePerYearData',
      fiscalYearIdKey: 'salePerYearFiscalYearId',
      fiscalYearNameKey: 'salePerYearFiscalYearName',
      selectedRevenueAccountIdKey: 'salePerYearSelectedRevenueAccountId',
      selectedRevenueAccountNameKey: 'salePerYearSelectedRevenueAccountName',
      valueKeys: [
        'sale_per_year',
        'salePerYear',
        'year_sale',
        'yearly_sale',
        'delivery_value',
        'total_delivery_value',
        'sale',
        'value',
      ],
    },
    sale_per_month: {
      title: 'Sale Per Month',
      revenueLoadingKey: 'salePerMonthRevenueLoading',
      revenueDataKey: 'salePerMonthRevenueData',
      departmentLoadingKey: 'salePerMonthLoading',
      departmentDataKey: 'salePerMonthData',
      fiscalYearIdKey: 'salePerMonthFiscalYearId',
      fiscalYearNameKey: 'salePerMonthFiscalYearName',
      selectedRevenueAccountIdKey: 'salePerMonthSelectedRevenueAccountId',
      selectedRevenueAccountNameKey: 'salePerMonthSelectedRevenueAccountName',
      valueKeys: [
        'sale_per_month',
        'salePerMonth',
        'monthly_sale',
        'delivery_value',
        'total_delivery_value',
        'sale',
        'value',
      ],
    },
    sale_today: {
      title: 'Sale Today',
      revenueLoadingKey: 'saleTodayRevenueLoading',
      revenueDataKey: 'saleTodayRevenueData',
      departmentLoadingKey: 'saleTodayLoading',
      departmentDataKey: 'saleTodayData',
      fiscalYearIdKey: 'saleTodayFiscalYearId',
      fiscalYearNameKey: 'saleTodayFiscalYearName',
      selectedRevenueAccountIdKey: 'saleTodaySelectedRevenueAccountId',
      selectedRevenueAccountNameKey: 'saleTodaySelectedRevenueAccountName',
      valueKeys: [
        'sale_today',
        'saleToday',
        'today_sale',
        'total_sale_today',
        'delivery_value',
        'total_delivery_value',
        'sale',
        'value',
      ],
    },
  }

  getDefaultCardTableState = () => ({
    summaryValue: 0,
    rows: [],
    totalRow: null,
  })

  getTablePaginationConfig = (totalRecords) => ({
    defaultPageSize: 10,
    pageSizeOptions: ['10', '20', '50', '100'],
    showSizeChanger: totalRecords > 10,
    showQuickJumper: totalRecords > 20,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
  })

  componentDidMount() {
    drilldown(Highcharts)
    this.loadFiscalYears(true)
    this.setState({ isLoading: true })
    this.getSalesData().finally(() => {
      this.setState({ isLoading: false })
    })
  }

  loadFiscalYears = (loadInitialCards = false) => {
    this.dropdownData(
      'fiscal_years',
      {},
      [
        (fiscalYears) => {
          const currentFiscalYearId = +wtGetFromLocalStorage('fiscalYearId', 0)
          const selectedFiscalYear =
            fiscalYears.find((item) => +item.value === currentFiscalYearId) || fiscalYears[0]

          this.setState(
            {
              fiscalYears,
              defaultFiscalYearId: selectedFiscalYear ? +selectedFiscalYear.value : 0,
              defaultFiscalYearName: selectedFiscalYear ? selectedFiscalYear.label : '',
              salePerYearFiscalYearId: selectedFiscalYear ? +selectedFiscalYear.value : 0,
              salePerYearFiscalYearName: selectedFiscalYear ? selectedFiscalYear.label : '',
              salePerMonthFiscalYearId: selectedFiscalYear ? +selectedFiscalYear.value : 0,
              salePerMonthFiscalYearName: selectedFiscalYear ? selectedFiscalYear.label : '',
              saleTodayFiscalYearId: selectedFiscalYear ? +selectedFiscalYear.value : 0,
              saleTodayFiscalYearName: selectedFiscalYear ? selectedFiscalYear.label : '',
              classWiseSalesFiscalYearId: selectedFiscalYear ? +selectedFiscalYear.value : 0,
              classWiseSalesFiscalYearName: selectedFiscalYear ? selectedFiscalYear.label : '',
              categoryWiseSalesFiscalYearId: selectedFiscalYear ? +selectedFiscalYear.value : 0,
              categoryWiseSalesFiscalYearName: selectedFiscalYear ? selectedFiscalYear.label : '',
            },
            () => {
              if (loadInitialCards && !this.state.hasInitialCardLoadRun) {
                this.loadInitialCards()
              }
            },
          )
        },
      ],
      1,
    )
  }

  loadInitialCards = () => {
    this.setState({ hasInitialCardLoadRun: true }, () => {
      this.getRevenueAccountSummaryData('sale_per_year')
      this.getFiscalYearSummaryData('sale_per_year')
      this.getRevenueAccountSummaryData('sale_per_month')
      this.getFiscalYearSummaryData('sale_per_month')
      this.getRevenueAccountSummaryData('sale_today')
      this.getFiscalYearSummaryData('sale_today')
      this.getClassWiseSalesData()
      this.getCategoryWiseSalesData()
    })
  }

  getSelectedBranchIdsParam = () => this.state.selectedBranchIds.join(',')

  refreshDashboardData = () => {
    this.setState({ isLoading: true })
    this.getSalesData().finally(() => {
      this.setState({ isLoading: false })
    })
    this.getRevenueAccountSummaryData('sale_per_year')
    this.getFiscalYearSummaryData('sale_per_year')
    this.getRevenueAccountSummaryData('sale_per_month')
    this.getFiscalYearSummaryData('sale_per_month')
    this.getRevenueAccountSummaryData('sale_today')
    this.getFiscalYearSummaryData('sale_today')
    this.getClassWiseSalesData()
    this.getCategoryWiseSalesData()
  }

  getSalesData() {
    return new Promise((resolve) => {
      wtApiCall(
        'sales_dashboard',
        {
          selected_branch_ids: this.getSelectedBranchIdsParam(),
        },
        'get',
        (result) => {
          if (result && result.data) {
            this.setState({
              SalesDashboardData: result.data,
            })
          }
          resolve()
        },
        (result) => {
          lzNotifyErrorMessageFromResult(result)
          resolve()
        },
      )
    })
  }

  getMetricValue = (record, keys = []) => {
    for (const key of keys) {
      if (record?.[key] !== undefined && record?.[key] !== null && record?.[key] !== '') {
        return parseFloat(record[key]) || 0
      }
    }

    return 0
  }

  formatNumberValue = (value, minimumFractionDigits = 2, maximumFractionDigits = 2) =>
    new Intl.NumberFormat('en-US', {
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(parseFloat(value) || 0)

  getFiscalYearRecord = (fiscalYearId) =>
    this.state.fiscalYears.find((item) => +item.value === +fiscalYearId) || null

  getSalesBreakupDateRange = (cardType) => {
    const config = this.salesCardConfig[cardType]
    const fiscalYearId = this.state[config.fiscalYearIdKey]
    const fiscalYear = this.getFiscalYearRecord(fiscalYearId)

    if (!fiscalYear?.start_date || !fiscalYear?.end_date) {
      return null
    }

    const startDate = dayjs(fiscalYear.start_date)
    const endDate = dayjs(fiscalYear.end_date)

    if (cardType === 'sale_today') {
      const today = dayjs()
      return {
        from_date: today.format('YYYY-MM-DD'),
        to_date: today.format('YYYY-MM-DD'),
      }
    }

    if (cardType === 'sale_per_month') {
      const monthIndex = Math.max(
        0,
        monthOptions.findIndex((item) => item.value === this.state.salePerMonthMonth),
      )
      let monthStart = startDate.month(monthIndex).startOf('month')

      if (monthStart.isBefore(startDate, 'day')) {
        monthStart = monthStart.add(1, 'year')
      }

      if (monthStart.isAfter(endDate, 'day')) {
        monthStart = monthStart.subtract(1, 'year')
      }

      return {
        from_date: monthStart.format('YYYY-MM-DD'),
        to_date: monthStart.endOf('month').format('YYYY-MM-DD'),
      }
    }

    return {
      from_date: startDate.format('YYYY-MM-DD'),
      to_date: endDate.format('YYYY-MM-DD'),
    }
  }

  openSaleBreakupReport = (
    cardType,
    departmentId = 0,
    departmentName = '',
    revenueAccountId = 0,
    revenueAccountName = '',
  ) => {
    const dateRange = this.getSalesBreakupDateRange(cardType)
    if (!dateRange) {
      return
    }

    wtSaveToLocalStorage('sale_order_delivery_report_drilldown', {
      from_date: dateRange.from_date,
      to_date: dateRange.to_date,
      department_id: +departmentId > 0 ? +departmentId : 0,
      department_name: departmentName || '',
      revenue_account_id: +revenueAccountId > 0 ? +revenueAccountId : 0,
      revenue_account_name: revenueAccountName || '',
      selected_branch_ids: this.state.selectedBranchIds,
    })

    window.open('/reports#code:sale-order-delivery-report', '_blank', 'noopener,noreferrer')
  }

  exportRowsToExcel = (rows, columns, fileName) => {
    const exportableRows = (rows || []).map((row) => {
      const exportRow = {}

      columns.forEach((column) => {
        if (!column?.dataIndex) {
          return
        }

        exportRow[column.title] = row[column.dataIndex]
      })

      return exportRow
    })

    const worksheet = XLSX.utils.json_to_sheet(exportableRows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report')
    XLSX.writeFile(workbook, `${fileName}.xlsx`)
  }

  parseSalesCardResponse = (responseData, cardType, basis = 'department') => {
    const config = this.salesCardConfig[cardType]
    const records = Array.isArray(responseData)
      ? responseData
      : responseData?.records || responseData?.rows || responseData?.data || []

    const idKey = basis === 'revenue_account' ? 'revenue_account_id' : 'department_id'
    const nameKey = basis === 'revenue_account' ? 'revenue_account_name' : 'department_name'

    const rows = records
      .map((item, index) => ({
        key: item?.id || `${cardType}-${index}`,
        [idKey]: item?.[idKey] || item?.id || 0,
        [nameKey]:
          item?.[nameKey] ||
          item?.department_name ||
          item?.revenue_account_name ||
          item?.department ||
          item?.revenue_account ||
          item?.department_title ||
          item?.name ||
          'N/A',
        value: this.getMetricValue(item, config.valueKeys),
      }))
      .sort((a, b) => {
        if (['sale_per_year', 'sale_per_month', 'sale_today'].includes(cardType)) {
          return (parseFloat(b.value) || 0) - (parseFloat(a.value) || 0)
        }

        return 0
      })

    const summaryValue = this.getMetricValue(responseData, config.valueKeys) || rows.reduce(
      (sum, item) => sum + (parseFloat(item.value) || 0),
      0,
    )

    return {
      summaryValue,
      rows,
      totalRow: {
        key: `${cardType}-total`,
        [nameKey]: 'Total',
        value: summaryValue,
      },
    }
  }

  getRevenueAccountSummaryData(cardType) {
    const config = this.salesCardConfig[cardType]
    const fiscalYearId = this.state[config.fiscalYearIdKey]
    const requestData = {
      fiscal_year_id: fiscalYearId,
      report_type: cardType,
      report_basis: 'revenue_account',
      selected_branch_ids: this.getSelectedBranchIdsParam(),
    }

    if (!(+fiscalYearId > 0)) {
      this.setState({
        [config.revenueDataKey]: null,
      })
      return
    }

    this.setState({ [config.revenueLoadingKey]: true })

    if (cardType === 'sale_per_month') {
      requestData.month = this.state.salePerMonthMonth
    }

    wtApiCall(
      'get_sales_data_based_on_fiscal_year',
      requestData,
      'get',
      (result) => {
        this.setState({
          [config.revenueDataKey]: this.parseSalesCardResponse(result?.data, cardType, 'revenue_account'),
          [config.revenueLoadingKey]: false,
        })
      },
      (result) => {
        lzNotifyErrorMessageFromResult(result)
        this.setState({
          [config.revenueDataKey]: null,
          [config.revenueLoadingKey]: false,
        })
      },
    )
  }

  getFiscalYearSummaryData(cardType) {
    const config = this.salesCardConfig[cardType]
    const fiscalYearId = this.state[config.fiscalYearIdKey]
    const requestData = {
      fiscal_year_id: fiscalYearId,
      report_type: cardType,
      report_basis: 'department',
      revenue_account_id: this.state[config.selectedRevenueAccountIdKey] || 0,
      selected_branch_ids: this.getSelectedBranchIdsParam(),
    }

    if (!(+fiscalYearId > 0)) {
      this.setState({
        [config.departmentDataKey]: null,
      })
      return
    }

    this.setState({ [config.departmentLoadingKey]: true })

    if (cardType === 'sale_per_month') {
      requestData.month = this.state.salePerMonthMonth
    }

    wtApiCall(
      'get_sales_data_based_on_fiscal_year',
      requestData,
      'get',
      (result) => {
        this.setState({
          [config.departmentDataKey]: this.parseSalesCardResponse(result?.data, cardType, 'department'),
          [config.departmentLoadingKey]: false,
        })
      },
      (result) => {
        lzNotifyErrorMessageFromResult(result)
        this.setState({
          [config.departmentDataKey]: null,
          [config.departmentLoadingKey]: false,
        })
      },
    )
  }

  handleFiscalYearChange = (cardType, value) => {
    const config = this.salesCardConfig[cardType]
    this.setState({
      [config.fiscalYearIdKey]: value?.value || 0,
      [config.fiscalYearNameKey]: value?.label || '',
      [config.revenueDataKey]: null,
      [config.departmentDataKey]: null,
      [config.selectedRevenueAccountIdKey]: 0,
      [config.selectedRevenueAccountNameKey]: '',
    })
  }

  handleRevenueAccountDrilldown = (cardType, record) => {
    const config = this.salesCardConfig[cardType]
    this.setState(
      {
        [config.selectedRevenueAccountIdKey]: record?.revenue_account_id || 0,
        [config.selectedRevenueAccountNameKey]: record?.revenue_account_name || '',
      },
      () => this.getFiscalYearSummaryData(cardType),
    )
  }

  clearRevenueAccountDrilldown = (cardType) => {
    const config = this.salesCardConfig[cardType]
    this.setState(
      {
        [config.selectedRevenueAccountIdKey]: 0,
        [config.selectedRevenueAccountNameKey]: '',
      },
      () => this.getFiscalYearSummaryData(cardType),
    )
  }

  getFlippableCardMinHeight = (cardType) => {
    const config = this.salesCardConfig[cardType]
    const revenueRows = this.state[config.revenueDataKey]?.rows || []
    const departmentRows = this.state[config.departmentDataKey]?.rows || []
    const visibleRows = Math.min(Math.max(revenueRows.length, departmentRows.length, 1), 10)
    const baseHeight = 315
    const rowHeight = 32
    const paginationHeight = revenueRows.length > 10 || departmentRows.length > 10 ? 78 : 28
    const summaryHeight = 48

    return baseHeight + visibleRows * rowHeight + summaryHeight + paginationHeight
  }

  renderSalesCardFilters = (cardType, basis = 'revenue') => {
    const config = this.salesCardConfig[cardType]
    const fiscalYearId = this.state[config.fiscalYearIdKey]
    const fiscalYearName = this.state[config.fiscalYearNameKey]
    const isSalePerMonthCard = cardType === 'sale_per_month'

    return (
      <CRow className="mb-3 sales-dashboard-filter-row" style={{ alignItems: 'end' }}>
        <CCol md={isSalePerMonthCard ? '5' : '8'}>
          <label className="sales-dashboard-field-label">Fiscal Year</label>
          <WidgetFiscalYearSelector
            size="sm"
            value={fiscalYearId}
            displayValue={fiscalYearName}
            fiscalYears={this.state.fiscalYears}
            onChange={(value) => this.handleFiscalYearChange(cardType, value)}
            reloadDropdownData={() => this.loadFiscalYears()}
            showCloudIcon={true}
          />
        </CCol>
        {isSalePerMonthCard && (
          <CCol md="4">
            <label className="sales-dashboard-field-label">Month</label>
            <Select
              value={this.state.salePerMonthMonth}
              options={monthOptions}
              onChange={(value) =>
                this.setState({
                  salePerMonthMonth: value,
                  [config.revenueDataKey]: null,
                  [config.departmentDataKey]: null,
                  [config.selectedRevenueAccountIdKey]: 0,
                  [config.selectedRevenueAccountNameKey]: '',
                })}
              style={{ width: '100%' }}
            />
          </CCol>
        )}
        <CCol md={isSalePerMonthCard ? '3' : '4'}>
          <Button
            type="primary"
            loading={this.state[basis === 'revenue' ? config.revenueLoadingKey : config.departmentLoadingKey]}
            onClick={() =>
              basis === 'revenue'
                ? this.getRevenueAccountSummaryData(cardType)
                : this.getFiscalYearSummaryData(cardType)
            }
            disabled={!(+fiscalYearId > 0)}
            className="sales-dashboard-show-btn"
          >
            Show
          </Button>
        </CCol>
      </CRow>
    )
  }



  parseDateRangeSectionResponse = (responseData) => {
    const records = Array.isArray(responseData)
      ? responseData
      : responseData?.records || responseData?.rows || responseData?.data || []

    return records.map((item, index) => ({
      key: item?.id || `date-range-section-${index}`,
      department_name:
        item?.department_name || item?.department || item?.department_title || item?.name || 'N/A',
      sales_excl_taxes:
        parseFloat(
          item?.sales_excl_taxes || item?.sales_excl_tax || item?.sale_excl_taxes || item?.sale || 0,
        ) || 0,
      gst: parseFloat(item?.gst || item?.sales_tax || 0) || 0,
      further_tax: parseFloat(item?.further_tax || 0) || 0,
      income_tax: parseFloat(item?.income_tax || 0) || 0,
      grand_total:
        parseFloat(
          item?.grand_total || item?.total || item?.delivery_value || item?.total_delivery_value || 0,
        ) || 0,
    }))
  }

  parseCategoryWiseSalesResponse = (responseData) => {
    const records = Array.isArray(responseData)
      ? responseData
      : responseData?.records || responseData?.rows || responseData?.data || []

    const rows = records
      .map((item, index) => ({
        key: item?.id || `category-wise-sales-${index}`,
        category:
          item?.category || item?.category_name || item?.item_category || item?.name || 'N/A',
        qty:
          parseFloat(item?.qty || item?.quantity || item?.total_qty || item?.delivered_qty || 0) ||
          0,
        value:
          parseFloat(
            item?.value ||
            item?.sale ||
            item?.sales_value ||
            item?.delivery_value ||
            item?.total_delivery_value ||
            0,
          ) || 0,
      }))
      .sort((a, b) => (parseFloat(b.value) || 0) - (parseFloat(a.value) || 0))

    const totalQty =
      parseFloat(
        responseData?.qty || responseData?.quantity || responseData?.total_qty || responseData?.delivered_qty || 0,
      ) || rows.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0)

    const totalValue =
      parseFloat(
        responseData?.value ||
        responseData?.sale ||
        responseData?.sales_value ||
        responseData?.delivery_value ||
        responseData?.total_delivery_value ||
        0,
      ) || rows.reduce((sum, item) => sum + (parseFloat(item.value) || 0), 0)

    return {
      rows,
      totalRow: {
        key: 'category-wise-sales-total',
        category: 'Total',
        qty: totalQty,
        value: totalValue,
      },
    }
  }

  parseClassWiseSalesResponse = (responseData) => {
    const records = Array.isArray(responseData)
      ? responseData
      : responseData?.records || responseData?.rows || responseData?.data || []

    const rows = records
      .map((item, index) => ({
        key: item?.id || `class-wise-sales-${index}`,
        class_name:
          item?.class_name || item?.class || item?.class_title || item?.name || 'N/A',
        qty:
          parseFloat(item?.qty || item?.quantity || item?.total_qty || item?.delivered_qty || 0) ||
          0,
        value:
          parseFloat(
            item?.value ||
            item?.sale ||
            item?.sales_value ||
            item?.delivery_value ||
            item?.total_delivery_value ||
            0,
          ) || 0,
      }))
      .sort((a, b) => (parseFloat(b.value) || 0) - (parseFloat(a.value) || 0))

    const totalQty =
      parseFloat(
        responseData?.qty ||
        responseData?.quantity ||
        responseData?.total_qty ||
        responseData?.delivered_qty ||
        0,
      ) || rows.reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0)

    const totalValue =
      parseFloat(
        responseData?.value ||
        responseData?.sale ||
        responseData?.sales_value ||
        responseData?.delivery_value ||
        responseData?.total_delivery_value ||
        0,
      ) || rows.reduce((sum, item) => sum + (parseFloat(item.value) || 0), 0)

    return {
      rows,
      totalRow: {
        key: 'class-wise-sales-total',
        class_name: 'Total',
        qty: totalQty,
        value: totalValue,
      },
    }
  }

  getCategoryWiseSalesData = () => {
    const { categoryWiseSalesFiscalYearId } = this.state

    if (!(+categoryWiseSalesFiscalYearId > 0)) {
      this.setState({ categoryWiseSalesData: { rows: [], totalRow: null } })
      return
    }

    this.setState({ categoryWiseSalesLoading: true })

    wtApiCall(
      'get_category_wise_sales_data',
      {
        fiscal_year_id: categoryWiseSalesFiscalYearId,
        selected_branch_ids: this.getSelectedBranchIdsParam(),
      },
      'get',
      (result) => {
        this.setState({
          categoryWiseSalesData: this.parseCategoryWiseSalesResponse(result?.data),
          categoryWiseSalesLoading: false,
        })
      },
      (result) => {
        lzNotifyErrorMessageFromResult(result)
        this.setState({
          categoryWiseSalesData: { rows: [], totalRow: null },
          categoryWiseSalesLoading: false,
        })
      },
    )
  }

  getClassWiseSalesData = () => {
    const { classWiseSalesFiscalYearId } = this.state

    if (!(+classWiseSalesFiscalYearId > 0)) {
      this.setState({ classWiseSalesData: { rows: [], totalRow: null } })
      return
    }

    this.setState({ classWiseSalesLoading: true })

    wtApiCall(
      'get_class_wise_sales_data',
      {
        fiscal_year_id: classWiseSalesFiscalYearId,
        selected_branch_ids: this.getSelectedBranchIdsParam(),
      },
      'get',
      (result) => {
        this.setState({
          classWiseSalesData: this.parseClassWiseSalesResponse(result?.data),
          classWiseSalesLoading: false,
        })
      },
      (result) => {
        lzNotifyErrorMessageFromResult(result)
        this.setState({
          classWiseSalesData: { rows: [], totalRow: null },
          classWiseSalesLoading: false,
        })
      },
    )
  }

  renderCategoryWiseSalesCard = () => {
    const {
      categoryWiseSalesFiscalYearId,
      categoryWiseSalesFiscalYearName,
      categoryWiseSalesLoading,
      categoryWiseSalesData,
      fiscalYears,
    } = this.state
    const categoryRows = categoryWiseSalesData?.rows || []
    const categoryTotalRow = categoryWiseSalesData?.totalRow

    const columns = [
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        render: (text, record) => (
          <span style={{ fontWeight: record.category === 'Total' ? 'bold' : 'normal' }}>{text}</span>
        ),
      },
      {
        title: 'QTY',
        dataIndex: 'qty',
        key: 'qty',
        align: 'right',
        render: (text, record) => (
          <span style={{ fontWeight: record.category === 'Total' ? 'bold' : 'normal' }}>
            {this.formatNumberValue(text || 0)}
          </span>
        ),
      },
      {
        title: 'Value',
        dataIndex: 'value',
        key: 'value',
        align: 'right',
        render: (text, record) => (
          <span style={{ fontWeight: record.category === 'Total' ? 'bold' : 'normal' }}>
            {this.formatNumberValue(text || 0)}
          </span>
        ),
      },
    ]

    return (
      <CCol md="6">
        <CCard className="mb-4 sales-dashboard-table-card">
          <CCardBody className="sales-dashboard-card-body">
            <div className="sales-dashboard-card-header">
              <div className="sales-dashboard-card-title">Category Wise Sales</div>
              <Button
                type="default"
                size="small"
                className="sales-dashboard-export-btn"
                onClick={() =>
                  this.exportRowsToExcel(
                    categoryTotalRow ? [...categoryRows, categoryTotalRow] : categoryRows,
                    columns,
                    `category-wise-sales-${dayjs().format('YYYY-MM-DD')}`,
                  )
                }
                disabled={!categoryRows.length}
              >
                Export Excel
              </Button>
            </div>

            <CRow className="mb-3 sales-dashboard-filter-row" style={{ alignItems: 'end' }}>
              <CCol md="6">
                <label className="sales-dashboard-field-label">Fiscal Year</label>
                <WidgetFiscalYearSelector
                  size="sm"
                  value={categoryWiseSalesFiscalYearId}
                  displayValue={categoryWiseSalesFiscalYearName}
                  fiscalYears={fiscalYears}
                  onChange={(value) =>
                    this.setState({
                      categoryWiseSalesFiscalYearId: value?.value || 0,
                      categoryWiseSalesFiscalYearName: value?.label || '',
                      categoryWiseSalesData: { rows: [], totalRow: null },
                    })}
                  reloadDropdownData={() => this.loadFiscalYears()}
                  showCloudIcon={true}
                />
              </CCol>
              <CCol md="2">
                <Button
                  type="primary"
                  onClick={this.getCategoryWiseSalesData}
                  loading={categoryWiseSalesLoading}
                  disabled={!(+categoryWiseSalesFiscalYearId > 0)}
                  className="sales-dashboard-show-btn"
                >
                  Show
                </Button>
              </CCol>
            </CRow>

            <div className="sales-dashboard-table-wrap">
              <Table
                bordered
                size="small"
                columns={columns}
                dataSource={categoryRows}
                loading={categoryWiseSalesLoading}
                pagination={this.getTablePaginationConfig(categoryRows.length)}
                locale={{ emptyText: 'No data loaded' }}
                summary={() =>
                  categoryTotalRow ? (
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0}>
                        <strong>{categoryTotalRow.category}</strong>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} align="right">
                        <strong>{this.formatNumberValue(categoryTotalRow.qty || 0)}</strong>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} align="right">
                        <strong>{this.formatNumberValue(categoryTotalRow.value || 0)}</strong>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  ) : null
                }
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    )
  }

  renderFlippableSalesCard = (cardType) => {
    const config = this.salesCardConfig[cardType]
    const selectedRevenueAccountId = this.state[config.selectedRevenueAccountIdKey]
    const selectedRevenueAccountName = this.state[config.selectedRevenueAccountNameKey]
    const isFlipped = +selectedRevenueAccountId > 0

    const revenueData = this.state[config.revenueDataKey]
    const revenueRows = revenueData?.rows || []
    const revenueTotalRow = revenueData?.totalRow
    const revenueColumns = [
      {
        title: 'Revenue Account',
        dataIndex: 'revenue_account_name',
        key: 'revenue_account_name',
        render: (text, record) => (
          <span style={{ fontWeight: record.revenue_account_name === 'Total' ? 'bold' : 'normal' }}>
            {text}
          </span>
        ),
      },
      {
        title: 'Amount (Rs.)',
        dataIndex: 'value',
        key: 'value',
        align: 'right',
        render: (text, record) => (
          <button
            type="button"
            className="sales-dashboard-breakup-link"
            style={{ fontWeight: record.revenue_account_name === 'Total' ? 'bold' : 'normal' }}
            onClick={() => this.handleRevenueAccountDrilldown(cardType, record)}
            title="Show department-wise data"
          >
            {this.formatNumberValue(text || 0)}
          </button>
        ),
      },
    ]

    const departmentData = this.state[config.departmentDataKey]
    const departmentRows = departmentData?.rows || []
    const departmentTotalRow = departmentData?.totalRow
    const departmentColumns = [
      {
        title: 'Department Name',
        dataIndex: 'department_name',
        key: 'department_name',
        render: (text, record) => (
          <span style={{ fontWeight: record.department_name === 'Total' ? 'bold' : 'normal' }}>
            {text}
          </span>
        ),
      },
      {
        title: 'Amount (Rs.)',
        dataIndex: 'value',
        key: 'value',
        align: 'right',
        render: (text, record) => (
          <button
            type="button"
            className="sales-dashboard-breakup-link"
            style={{ fontWeight: record.department_name === 'Total' ? 'bold' : 'normal' }}
            onClick={() =>
              this.openSaleBreakupReport(
                cardType,
                record.department_id || 0,
                record.department_name || '',
                selectedRevenueAccountId,
                selectedRevenueAccountName,
              )
            }
            title="Open sales breakup"
          >
            {this.formatNumberValue(text || 0)}
          </button>
        ),
      },
    ]

    return (
      <CCol md="4">
        <div className={`sales-dashboard-flip-card ${isFlipped ? 'is-flipped' : ''}`}>
          <div
            className="sales-dashboard-flip-card-inner"
            style={{ minHeight: `${this.getFlippableCardMinHeight(cardType)}px` }}
          >
            <div className="sales-dashboard-flip-face">
              <CCard className="mb-4 sales-dashboard-table-card sales-dashboard-flip-face-card">
                <CCardBody className="sales-dashboard-card-body">
                  <div className="sales-dashboard-card-header">
                    <div className="sales-dashboard-card-title">{config.title}</div>
                    <Button
                      type="default"
                      size="small"
                      className="sales-dashboard-export-btn"
                      onClick={() =>
                        this.exportRowsToExcel(
                          revenueTotalRow ? [...revenueRows, revenueTotalRow] : revenueRows,
                          revenueColumns,
                          `${cardType}-revenue-accounts-${dayjs().format('YYYY-MM-DD')}`,
                        )
                      }
                      disabled={!revenueRows.length}
                    >
                      Export Excel
                    </Button>
                  </div>

                  <div className="sales-dashboard-card-subtitle">Revenue Account Wise (MN)</div>
                  {this.renderSalesCardFilters(cardType, 'revenue')}

                  <div className="sales-dashboard-table-wrap">
                    <Table
                      bordered
                      size="small"
                      loading={this.state[config.revenueLoadingKey]}
                      columns={revenueColumns}
                      dataSource={revenueRows}
                      pagination={this.getTablePaginationConfig(revenueRows.length)}
                      locale={{ emptyText: 'No data loaded' }}
                      summary={() =>
                        revenueTotalRow ? (
                          <Table.Summary.Row>
                            <Table.Summary.Cell index={0}>
                              <strong>{revenueTotalRow.revenue_account_name}</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align="right">
                              <strong>{this.formatNumberValue(revenueTotalRow.value || 0)}</strong>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        ) : null
                      }
                    />
                  </div>
                </CCardBody>
              </CCard>
            </div>

            <div className="sales-dashboard-flip-face sales-dashboard-flip-face-back">
              <CCard className="mb-4 sales-dashboard-table-card sales-dashboard-flip-face-card">
                <CCardBody className="sales-dashboard-card-body">
                  <div className="sales-dashboard-card-header">
                    <div>
                      <div className="sales-dashboard-card-title">{config.title}</div>
                      <div className="sales-dashboard-card-subtitle">
                        Department Wise (MN)
                        {selectedRevenueAccountName ? ` • ${selectedRevenueAccountName}` : ''}
                      </div>
                    </div>
                    <div className="sales-dashboard-card-header-actions">
                      <Button
                        type="default"
                        size="small"
                        className="sales-dashboard-export-btn"
                        onClick={() => this.clearRevenueAccountDrilldown(cardType)}
                      >
                        Back
                      </Button>
                      <Button
                        type="default"
                        size="small"
                        className="sales-dashboard-export-btn"
                        onClick={() =>
                          this.exportRowsToExcel(
                            departmentTotalRow ? [...departmentRows, departmentTotalRow] : departmentRows,
                            departmentColumns,
                            `${cardType}-departments-${dayjs().format('YYYY-MM-DD')}`,
                          )
                        }
                        disabled={!departmentRows.length}
                      >
                        Export Excel
                      </Button>
                    </div>
                  </div>

                  {this.renderSalesCardFilters(cardType, 'department')}

                  <div className="sales-dashboard-table-wrap">
                    <Table
                      bordered
                      size="small"
                      loading={this.state[config.departmentLoadingKey]}
                      columns={departmentColumns}
                      dataSource={departmentRows}
                      pagination={this.getTablePaginationConfig(departmentRows.length)}
                      locale={{ emptyText: 'Click a revenue account to load department-wise data' }}
                      summary={() =>
                        departmentTotalRow ? (
                          <Table.Summary.Row>
                            <Table.Summary.Cell index={0}>
                              <strong>{departmentTotalRow.department_name}</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align="right">
                              <button
                                type="button"
                                className="sales-dashboard-breakup-link"
                                style={{ fontWeight: 'bold' }}
                                onClick={() =>
                                  this.openSaleBreakupReport(
                                    cardType,
                                    0,
                                    '',
                                    selectedRevenueAccountId,
                                    selectedRevenueAccountName,
                                  )
                                }
                                title="Open sales breakup"
                              >
                                {this.formatNumberValue(departmentTotalRow.value || 0)}
                              </button>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        ) : null
                      }
                    />
                  </div>
                </CCardBody>
              </CCard>
            </div>
          </div>
        </div>
      </CCol>
    )
  }

  renderClassWiseSalesCard = () => {
    const {
      classWiseSalesFiscalYearId,
      classWiseSalesFiscalYearName,
      classWiseSalesLoading,
      classWiseSalesData,
      fiscalYears,
    } = this.state
    const classRows = classWiseSalesData?.rows || []
    const classTotalRow = classWiseSalesData?.totalRow

    const columns = [
      {
        title: 'Class',
        dataIndex: 'class_name',
        key: 'class_name',
        render: (text, record) => (
          <span style={{ fontWeight: record.class_name === 'Total' ? 'bold' : 'normal' }}>
            {text}
          </span>
        ),
      },
      {
        title: 'QTY',
        dataIndex: 'qty',
        key: 'qty',
        align: 'right',
        render: (text, record) => (
          <span style={{ fontWeight: record.class_name === 'Total' ? 'bold' : 'normal' }}>
            {this.formatNumberValue(text || 0)}
          </span>
        ),
      },
      {
        title: 'Value',
        dataIndex: 'value',
        key: 'value',
        align: 'right',
        render: (text, record) => (
          <span style={{ fontWeight: record.class_name === 'Total' ? 'bold' : 'normal' }}>
            {this.formatNumberValue(text || 0)}
          </span>
        ),
      },
    ]

    return (
      <CCol md="6">
        <CCard className="mb-4 sales-dashboard-table-card">
          <CCardBody className="sales-dashboard-card-body">
            <div className="sales-dashboard-card-header">
              <div className="sales-dashboard-card-title">Class Wise Sales</div>
              <Button
                type="default"
                size="small"
                className="sales-dashboard-export-btn"
                onClick={() =>
                  this.exportRowsToExcel(
                    classTotalRow ? [...classRows, classTotalRow] : classRows,
                    columns,
                    `class-wise-sales-${dayjs().format('YYYY-MM-DD')}`,
                  )
                }
                disabled={!classRows.length}
              >
                Export Excel
              </Button>
            </div>

            <CRow className="mb-3 sales-dashboard-filter-row" style={{ alignItems: 'end' }}>
              <CCol md="6">
                <label className="sales-dashboard-field-label">Fiscal Year</label>
                <WidgetFiscalYearSelector
                  size="sm"
                  value={classWiseSalesFiscalYearId}
                  displayValue={classWiseSalesFiscalYearName}
                  fiscalYears={fiscalYears}
                  onChange={(value) =>
                    this.setState({
                      classWiseSalesFiscalYearId: value?.value || 0,
                      classWiseSalesFiscalYearName: value?.label || '',
                      classWiseSalesData: { rows: [], totalRow: null },
                    })}
                  reloadDropdownData={() => this.loadFiscalYears()}
                  showCloudIcon={true}
                />
              </CCol>
              <CCol md="2">
                <Button
                  type="primary"
                  onClick={this.getClassWiseSalesData}
                  loading={classWiseSalesLoading}
                  disabled={!(+classWiseSalesFiscalYearId > 0)}
                  className="sales-dashboard-show-btn"
                >
                  Show
                </Button>
              </CCol>
            </CRow>

            <div className="sales-dashboard-table-wrap">
              <Table
                bordered
                size="small"
                columns={columns}
                dataSource={classRows}
                loading={classWiseSalesLoading}
                pagination={this.getTablePaginationConfig(classRows.length)}
                locale={{ emptyText: 'No data loaded' }}
                summary={() =>
                  classTotalRow ? (
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0}>
                        <strong>{classTotalRow.class_name}</strong>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} align="right">
                        <strong>{this.formatNumberValue(classTotalRow.qty || 0)}</strong>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} align="right">
                        <strong>{this.formatNumberValue(classTotalRow.value || 0)}</strong>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  ) : null
                }
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    )
  }

  renderOverviewCard = ({ title, count, value, icon, alt, onClick, accentClass = '' }) => (
    <CCol md="2" sm="6">
      <div className="sales-dashboard-overview-col">
        <button
          type="button"
          className={`sales-dashboard-overview-card ${accentClass}`.trim()}
          onClick={onClick}
        >
          <div className="sales-dashboard-overview-main">
            <div className="sales-dashboard-overview-icon-wrap">
              <img className="sales-dashboard-overview-icon" src={icon} alt={alt} />
            </div>
            <div className="sales-dashboard-overview-content">
              <div className="sales-dashboard-overview-title">{title}</div>
              {typeof count !== 'undefined' && (
                <div className="sales-dashboard-overview-count">{count}</div>
              )}
            </div>
          </div>
          {typeof value !== 'undefined' && value !== null && (
            <div className="sales-dashboard-overview-value-row">
              <div className="sales-dashboard-overview-value">{value} M</div>
            </div>
          )}
        </button>
      </div>
    </CCol>
  )
  render() {
    const {
      isLoading,
      SalesDashboardData,
      dateRange,
      dateRangeSectionLoading,
      dateRangeSectionData,
      branchOptions,
      selectedBranchIds,
    } = this.state

    if (isLoading) {
      return Loading
    }

    const dateRangeSectionColumns = [
      {
        title: 'Department Name',
        dataIndex: 'department_name',
        key: 'department_name',
      },
      {
        title: 'Sales Excl Taxes',
        dataIndex: 'sales_excl_taxes',
        key: 'sales_excl_taxes',
        align: 'right',
        render: (text) => wtRoundValue(text || 0, 2),
      },
      {
        title: 'GST',
        dataIndex: 'gst',
        key: 'gst',
        align: 'right',
        render: (text) => wtRoundValue(text || 0, 2),
      },
      {
        title: 'Further Tax',
        dataIndex: 'further_tax',
        key: 'further_tax',
        align: 'right',
        render: (text) => wtRoundValue(text || 0, 2),
      },
      {
        title: 'Income Tax',
        dataIndex: 'income_tax',
        key: 'income_tax',
        align: 'right',
        render: (text) => wtRoundValue(text || 0, 2),
      },
      {
        title: 'Grand Total',
        dataIndex: 'grand_total',
        key: 'grand_total',
        align: 'right',
        render: (text) => wtRoundValue(text || 0, 2),
      },
    ]

    const DeliveryDistributionByDepartment = SalesDashboardData
      ? SalesDashboardData.SaleOrderDistributionByDepartmentWise
        .map((item) => ({
          name: item.department_name,
          y: parseFloat(item.total_delivery_value),
          total_deliveries: parseFloat(item.total_deliveries),
        }))
        .sort((a, b) => b.y - a.y)
        .map((item, index) => ({
          ...item,
          color: index === 0 ? '#2E7D32' : undefined,
        }))
      : []

    const DeliveryDistributionChart = {
      chart: { type: 'pie', plotBackgroundColor: null, plotBorderWidth: null, plotShadow: false },
      title: { text: 'Deliveries (Department Wise)' },
      tooltip: {
        headerFormat: '<span style="font-size:13px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">Delivery Value:</td>' +
          '<td style="padding:0"><b>Rs. {point.y:,.2f} M</b></td></tr>' +
          '<tr><td style="color:{series.color};padding:0">Deliveries:</td>' +
          '<td style="padding:0"><b>{point.total_deliveries}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: { enabled: true, format: '<b>{point.name}</b>: {point.percentage:.1f} %' },
        },
      },
      series: [{ name: 'Delivery Value', colorByPoint: true, data: DeliveryDistributionByDepartment }],
    }

    const MonthWiseData = SalesDashboardData
      ? SalesDashboardData.MonthWiseDeliveries.map((item) => ({
        name: `${item.month_name} ${item.year}`,
        y: parseFloat(item.total_delivery_value),
        total_deliveries: parseFloat(item.total_deliveries),
      }))
      : []

    const MonthWiseDeliveryChart = {
      chart: { type: 'column' },
      title: { text: 'Month-wise Deliveries' },
      xAxis: { categories: MonthWiseData.map((item) => item.name), title: { text: 'Month' } },
      yAxis: {
        title: { text: 'Delivery Value (Rs.)' },
        labels: {
          formatter: function () {
            return '' + this.value.toLocaleString()
          },
        },
      },
      tooltip: {
        formatter: function () {
          return `<b>${this.point.name}</b><br/>
                  Total Deliveries: ${this.point.total_deliveries}<br/>
                  Delivery Value: Rs. ${this.point.y.toLocaleString()} M`
        },
      },
      plotOptions: { column: { dataLabels: { enabled: false } } },
      series: [{ name: 'Delivery Value', data: MonthWiseData, color: '#1C6BB8' }],
    }

    const overviewCards = SalesDashboardData
      ? [
        {
          title: 'Sales Today',
          value: wtFormatRoundedValue(SalesDashboardData.TotalDeliveryAmountToday, 'Rs. ', true, 3),
          icon: 'avatars/finance-dashboard-icons/asset.png',
          alt: 'do-today',
          onClick: () => window.open('/sale_order_deliveries'),
          accentClass: 'sales-dashboard-accent-blue',
        },
        {
          title: 'Sales This Month',
          value: wtFormatRoundedValue(SalesDashboardData.TotalDeliveryAmountThisMonth, 'Rs. ', true, 3),
          icon: 'avatars/finance-dashboard-icons/cash-inflow.png',
          alt: 'do-month',
          onClick: () => window.open('/sale_order_deliveries'),
          accentClass: 'sales-dashboard-accent-gold',
        },
        {
          title: 'Sales This Year',
          value: wtFormatRoundedValue(SalesDashboardData.TotalDeliveryAmountThisYear, 'Rs. ', true, 3),
          icon: 'avatars/finance-dashboard-icons/equity.png',
          alt: 'do-year',
          onClick: () => window.open('/sale_order_deliveries'),
          accentClass: 'sales-dashboard-accent-slate',
        },
        {
          title: 'CRF Accepted',
          count: SalesDashboardData.ContractReviewStatusSummary?.accepted_count || 0,
          icon: 'avatars/management-dashboard-icons/approval-performance-evaluation.png',
          alt: 'crf-accepted',
          onClick: () => this.props.navigate('/contract_review_form_details', { state: { scf_status: 1 } }),
          accentClass: 'sales-dashboard-accent-green',
        },
        {
          title: 'CRF Rejected',
          count: SalesDashboardData.ContractReviewStatusSummary?.rejected_count || 0,
          icon: 'avatars/finance-dashboard-icons/expense.png',
          alt: 'crf-rejected',
          onClick: () => this.props.navigate('/contract_review_form_details', { state: { scf_status: 2 } }),
          accentClass: 'sales-dashboard-accent-red',
        },
        {
          title: 'CRF In Process',
          count: SalesDashboardData.ContractReviewStatusSummary?.in_process_count || 0,
          icon: 'avatars/management-dashboard-icons/pending-performance-evaluation.png',
          alt: 'crf-inprocess',
          onClick: () => this.props.navigate('/contract_review_form_details', { state: { scf_status: 0 } }),
          accentClass: 'sales-dashboard-accent-slate',
        },
      ]
      : []


    return (
      <div
        className="container-fluid sales-dashboard-page"
        style={{ pointerEvents: isLoading ? 'none' : 'auto' }}
      >
        {SalesDashboardData && (
          <>
            <CRow className="sales-dashboard-page-header">
              <CCol md="8">
                <div className="sales-dashboard-hero">
                  <div className="sales-dashboard-eyebrow">Operations Overview</div>
                  <h4 className="sales-dashboard-heading">Sales Dashboard</h4>
                </div>
              </CCol>
              {!!branchOptions.length && (
                <CCol md="4">
                  <div className="sales-dashboard-hero sales-dashboard-branch-hero">
                    <label className="sales-dashboard-branch-label">Branches</label>
                    <div className="sales-dashboard-branch-controls">
                      <Select
                        mode="multiple"
                        allowClear
                        value={selectedBranchIds}
                        options={branchOptions.map((item) => ({
                          label: item.label || item.name,
                          value: +item.value || +item.id,
                        }))}
                        onChange={(values) =>
                          this.setState({
                            selectedBranchIds: values,
                          })
                        }
                        placeholder="Select branches"
                        maxTagCount="responsive"
                      />
                      <Button
                        type="primary"
                        onClick={this.refreshDashboardData}
                        className="sales-dashboard-branch-show-btn"
                      >
                        Show
                      </Button>
                    </div>
                  </div>
                </CCol>
              )}
            </CRow>

            <CRow className="sales-dashboard-overview-grid">
              <CCol md="12">
                <CRow>
                  {overviewCards.map((card, index) => (
                    <React.Fragment key={`${card.title}-${index}`}>
                      {this.renderOverviewCard(card)}
                    </React.Fragment>
                  ))}
                </CRow>
              </CCol>
            </CRow>

            <CRow className="sales-dashboard-section-row">
              <CCol md="6">
                <CCard className="mb-4 sales-dashboard-chart-card">
                  <CCardBody className="sales-dashboard-card-body">
                    <HighchartsReact highcharts={Highcharts} options={DeliveryDistributionChart} />
                  </CCardBody>
                </CCard>
              </CCol>

              <CCol md="6">
                <CCard className="mb-4 sales-dashboard-chart-card">
                  <CCardBody className="sales-dashboard-card-body">
                    <HighchartsReact highcharts={Highcharts} options={MonthWiseDeliveryChart} />
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>

            <CRow>
              {this.renderFlippableSalesCard('sale_per_year')}
              {this.renderFlippableSalesCard('sale_per_month')}
              {this.renderFlippableSalesCard('sale_today')}
            </CRow>
            <CRow>
              {this.renderClassWiseSalesCard()}
              {this.renderCategoryWiseSalesCard()}
            </CRow>
          </>
        )}
      </div>
    )
  }
}
export default WithRouter(SalesDashboard)
